// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".botPrompt-trigger{display:flex;justify-content:flex-end}\n", ""]);
// Exports
module.exports = exports;
